<template>
  <div>
    <div class="wrapper wrapper-content  animated fadeInRight">
      <order-header></order-header>
      <list></list>
    </div>
  </div>
</template>
<script>
import List from './Order/Content'
import Header from './Order/Header'
import axios from 'axios'
import { MAINTENANCE_ORDER_SET } from '../../../store/mutation-types'

export default {
  components: {
    list: List,
    orderHeader: Header
  },
  created () {
    axios.get('/maintenance/order/' + this.$route.params.id)
      .then(r => {
        this.$store.commit(MAINTENANCE_ORDER_SET, r.data)
      })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Order.vue